<template>
  <section class="solutions-section">
    <div class="container">
      <!-- Section Header -->
      <div class="section-header">
        <h2 class="section-title">行业解决方案</h2>
        
        <!-- Center Decor Element -->
        <div class="center-decor">
          <div class="line"></div>
          <div class="hexagon"></div>
          <div class="line"></div>
        </div>

        <p class="section-subtitle">
          聚焦行业痛点，融合数字技术与业务场景，提供端到端的整体解决方案，<br>助力企业降本增效、数字化升级。
        </p>
      </div>

      <!-- Solutions Grid -->
      <div class="solutions-grid">
        <!-- Card 1 -->
        <div class="solution-card">
          <div class="card-image">
            <img src="../assets/SolutionsSection/1.png" alt="私域流量解决方案" @error="handleImageError" />
          </div>
          <div class="card-content">
            <h3 class="card-title">私域流量解决方案</h3>
            <p class="card-desc">构建企业私域流量体系，实现客户沉淀、精细化运营与高效转化，提升客户全生命周期价值。</p>
            <div class="arrow-btn">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <line x1="5" y1="12" x2="19" y2="12"></line>
                <polyline points="12 5 19 12 12 19"></polyline>
              </svg>
            </div>
          </div>
        </div>

        <!-- Card 2 -->
        <div class="solution-card">
          <div class="card-image">
            <img src="../assets/SolutionsSection/2.png" alt="新零售解决方案" @error="handleImageError" />
          </div>
          <div class="card-content">
            <h3 class="card-title">新零售解决方案</h3>
            <p class="card-desc">打通线上线下全渠道，整合商品、会员、营销与交易数据，打造数字化新零售生态体系。</p>
            <div class="arrow-btn">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <line x1="5" y1="12" x2="19" y2="12"></line>
                <polyline points="12 5 19 12 12 19"></polyline>
              </svg>
            </div>
          </div>
        </div>

        <!-- Card 3 -->
        <div class="solution-card">
          <div class="card-image">
            <img src="../assets/SolutionsSection/3.png" alt="智慧工地解决方案" @error="handleImageError" />
          </div>
          <div class="card-content">
            <h3 class="card-title">智慧工地解决方案</h3>
            <p class="card-desc">运用人、机、料、法、环、测等数字化管理手段，提升施工效率，保障工程质量与安全。</p>
            <div class="arrow-btn">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <line x1="5" y1="12" x2="19" y2="12"></line>
                <polyline points="12 5 19 12 12 19"></polyline>
              </svg>
            </div>
          </div>
        </div>

        <!-- Card 4 -->
        <div class="solution-card">
          <div class="card-image">
            <img src="../assets/SolutionsSection/4.png" alt="数据服务 / 数字化转型方案" @error="handleImageError" />
          </div>
          <div class="card-content">
            <h3 class="card-title">数据服务 / 数字化转型方案</h3>
            <p class="card-desc">提供数据采集、治理、分析与可视化的全栈数字化能力，驱动业务洞察与创新，助力企业数字化转型。</p>
            <div class="arrow-btn">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <line x1="5" y1="12" x2="19" y2="12"></line>
                <polyline points="12 5 19 12 12 19"></polyline>
              </svg>
            </div>
          </div>
        </div>

      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'SolutionsSection',
  methods: {
    handleImageError(e) {
      // 占位处理：如果图片路径不对，显示一个浅色的默认区域
      e.target.src = 'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="300" height="200" fill="%23f0f4f8"><rect width="300" height="200"/></svg>';
    }
  }
}
</script>

<style scoped>
.solutions-section {
  padding: 80px 0 100px;
  background-color: #f7f9fc;
}

.container {
  max-width: 1640px; /* 宽屏设计 */
  margin: 0 auto;
  padding: 0 40px;
}

/* Header Styles */
.section-header {
  text-align: center;
  margin-bottom: 60px;
}

.section-title {
  font-size: 36px;
  color: #111;
  font-weight: 800;
  letter-spacing: 1px;
  margin-bottom: 20px;
}

.center-decor {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-bottom: 24px;
}

.center-decor .line {
  width: 40px;
  height: 2px;
  background: linear-gradient(to right, transparent, rgba(0, 82, 217, 0.4));
}

.center-decor .line:last-child {
  background: linear-gradient(to left, transparent, rgba(0, 82, 217, 0.4));
}

.hexagon {
  width: 12px;
  height: 12px;
  background-color: #0052d9;
  clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);
}

.section-subtitle {
  font-size: 16px;
  color: #666;
  line-height: 1.8;
}

/* Grid Styles */
.solutions-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
}

/* Card Styles */
.solution-card {
  background-color: #fcfcfd;
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  transition: all 0.3s ease;
}

.solution-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 40px rgba(0, 82, 217, 0.08);
  border-color: transparent;
}

.card-image {
  width: 100%;
  aspect-ratio: 4/3; /* 控制图片的比例 */
  background-color: #f4f8ff;
  overflow: hidden;
}

.card-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.solution-card:hover .card-image img {
  transform: scale(1.05); /* 悬停时图片微微放大 */
}

.card-content {
  padding: 32px 24px;
  display: flex;
  flex-direction: column;
  flex: 1;
}

.card-title {
  font-size: 20px;
  color: #111;
  font-weight: 700;
  margin-bottom: 16px;
}

.card-desc {
  font-size: 14px;
  color: #666;
  line-height: 1.8;
  margin: 0;
  flex: 1; /* 让描述部分撑开，使按钮沉底 */
  margin-bottom: 30px;
}

/* Arrow Button */
.arrow-btn {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 1px solid #e0e4e8;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #0052d9;
  background-color: #fff;
  transition: all 0.3s ease;
  cursor: pointer;
}

.solution-card:hover .arrow-btn {
  background-color: #0052d9;
  color: #fff;
  border-color: #0052d9;
}

/* Responsive adjustments */
@media (max-width: 1200px) {
  .solutions-grid {
    grid-template-columns: repeat(2, 1fr);
    row-gap: 40px;
  }
}

@media (max-width: 768px) {
  .solutions-grid {
    grid-template-columns: repeat(1, 1fr);
  }
}
</style>
